import React from 'react'
import styles from './HomeView.module.scss'

const HomeView = () => {
  return (
    <div>HomeView</div>
  )
}
export  default HomeView